import { message } from "antd";

const hardcodeToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiZWEwODRmMS1iOWI0LTQ2ZGEtYjZiZi1kNDg1YjE2YWJjZGQiLCJuYW1lIjoiQXJlZWogWmFoaWQgQWxpIiwiaW1hZ2UiOiJodHRwczovL3dvcmt3LmNvbS9SZXNvdXJjZXNcXDBhYjVmOWMwLWY5NDgtNGM0MC04ZGFkLWM1OGJhOTlmYjc2NVxcSW1hZ2VzXFxiZGM2YmM1NC0wNjAwLTQxOGYtYTM0OS1mMDIyMWRhYjU2MGYuanBlZyIsImVtYWlsIjoiYXJlZWpAbWlsZXRhcC5jb20iLCJidXNpbmVzc0lkIjoiMGFiNWY5YzAtZjk0OC00YzQwLThkYWQtYzU4YmE5OWZiNzY1IiwidmVyIjoiNzJBNEQ2OUQtNDgzMS00NzhGLUFFMDQtRUQ0ODI1MDlGRTkxIiwiaWgiOiJLZG8zUW94dUhmeUJCS1JhekUybGlOd0N3Z0VpM0I0OForcUVwd3UvOU04PSIsImlzIjoiM0JibkhtaXRjRFJaWWtENWwwNEdBUT09IiwicGgiOiJUL084TmhRbXhwL0lrYTVGR1MwL2RXWFkzV0JnSFNRemV5QTkySGNVRXpBPSIsInBzIjoiTjdQc2pQV0UxVGJEcnJ6b2hpQUZiUT09IiwianRpIjoiNjQwNmNlZDgtZjFlMS00MTRmLWIzMjgtZTJiYzYwY2Q1OGY0IiwibmJmIjoxNzYxOTk1MDIwLCJleHAiOjE3NjIxNjc4MjB9.Pg5tVf-fYJ8yJDMBcwZZhjlgn07ML2uMZN6zoneV6imL92cwj45hRI_S1xC8ACEIPRfE0T8TZduphnijFgUEppuXxaCcYJ5aXs4xCE76-niirGnOUPD7qg049HFHPGdcAZJiHUE7dxqXieAfvQAGF7DFqizRB8YBuV-Jbxnf0PJpxmB2jJHS4QImDML5oLP8PeU6Ao7X0Y36oDYTimEw3avyWrNcM3CQxpYRZoa4ujtyJDinoqBBkxzawCnnfLM7IlhIT1xdDUbYTpVVVgUtKId72JcjY1UhTjpu8hU_AAHn1AcRVlAtXTIOlDBnpUxaNJUhNnJiLRKteuh6_YD0Rw";

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`)
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
}

export function getWorkWiseAuthToken() {
  const searchParams = new URLSearchParams(document.location.search);
  let cookieToken = getCookieValue("token")
  let queryToken = searchParams.get("token");
  const finalToken = queryToken || cookieToken || hardcodeToken;
  return finalToken;
}
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const units = ["Bytes", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  if (unitIndex === 0) {
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1 && size < 50) {
    return `${parseFloat(size.toFixed(0))} ${units[unitIndex]}`;
  } else {
    return `${parseFloat(size.toFixed(2))} ${units[unitIndex]}`;
  }
};

export const getWatermarkData = async () => {
  const now = new Date();
  const currentDateTime = now.toLocaleString();

  // Get IP address
  let ip = 'N/A';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ip = data.ip;
  } catch (error) {
    console.error("Error fetching IP:", error);
    message.error("Could not fetch IP address");
  }

  // Get location
  let location = { lat: 'N/A', lng: 'N/A' };
  try {
    location = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        message.error("Geolocation not supported");
        return resolve(location);
      }

      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }),
        (error) => {
          handleGeolocationError(error);
          resolve(location); // Return default on error
        }
      );
    });
  } catch (error) {
    console.error("Location error:", error);
  }

  return {
    currentDateTime,
    ip,
    location
  };
};

const handleGeolocationError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      message.error("Location access denied. Please enable permissions.");
      break;
    case error.POSITION_UNAVAILABLE:
      message.error("Location information unavailable.");
      break;
    case error.TIMEOUT:
      message.error("Location request timed out.");
      break;
    default:
      message.error("Unknown location error occurred.");
  }
};

export const saveToLocalStorage = (docId, data) => {
  try {
    const localData = {
      data: data,
      lastUpdateTime: new Date().toISOString()
    };
    // Retrieve existing data from localStorage or initialize with an empty object
    const existingData = JSON.parse(localStorage.getItem('offlineBoardData')) || {};
    // Replace or add the sheet data for the given docId
    existingData[docId] = localData;
    // Save updated data back to localStorage
    localStorage.setItem('offlineBoardData', JSON.stringify(existingData));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const removeOfflineData = (id) => {
  const offlineData = JSON.parse(localStorage.getItem('offlineBoardData') || '{}');
  delete offlineData[id];
  localStorage.setItem('offlineBoardData', JSON.stringify(offlineData));
};

export const isOffline = () => {
  return !navigator.onLine;
};